var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430.72 278.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f58989;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: rgba(255, 255, 255, 0);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-5 {\n        opacity: .06;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        fill: #fccbac;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-12 {\n        fill: #efa278;\n      }\n\n      .cls-13 {\n        fill: #f4f2e4;\n      }\n\n      .cls-6 {\n        fill: #d7e9ec;\n        opacity: .59;\n      }\n\n      .cls-7 {\n        opacity: .04;\n      }\n\n      .cls-7, .cls-14, .cls-15, .cls-9 {\n        fill: none;\n      }\n\n      .cls-7, .cls-15, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-7, .cls-9 {\n        stroke: #000;\n        stroke-width: 2.5px;\n      }\n\n      .cls-16 {\n        fill: #e85d5d;\n      }\n\n      .cls-8 {\n        opacity: .1;\n      }\n\n      .cls-17 {\n        fill: #d3ba78;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-19 {\n        fill: #bf672c;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        stroke: #d8b96e;\n        stroke-width: 1.5px;\n      }\n\n      .cls-9 {\n        opacity: .08;\n      }\n\n      .cls-21 {\n        fill: #eac9c5;\n      }\n\n      .cls-22 {\n        fill: #fee9e6;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 106.2,
    width: 218.5,
    height: 262
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 106.2,
    width: 218.5,
    height: 262
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m243.14,161.59s29.2,15.5,85.9,9-35.1,41.9-35.1,41.9l-53,8.6-6.2-55.1,8.4-4.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 314.77,
    cy: 134,
    rx: 72,
    ry: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CakeBooked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "cakeShadow",
    className: "cls-6",
    cx: 215.2,
    cy: 239,
    rx: 128,
    ry: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "cake_booked",
    "data-name": "cake booked"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-10",
    d: "m112.7,204.4v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-19",
    d: "m215.6,258.2c-56.7,0-102.8-9.6-102.9-21.5h0v3.8h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-3.8h0c-.2,11.9-46.2,21.5-102.9,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-1",
    d: "m112.7,176.3v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-13",
    d: "m112.7,160.6v27.9h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-27.9H112.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-2",
    d: "m323.8,213.8c-1.6-2.8-2.4-5.9-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.4-2.9,12.1-.8,1.5-.9,3.3-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c-.1-3.5,2-6.7,5.3-7.9,1.1-.4,2.2-.4,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9s-1.8,14.4,0,19.6c1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.8,2.8.8,12.4.8,19.6,0,4.5-1.5,6.3-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.9-4.3-1.5-8.7-1.6-13.2,0-5.2.3-11.4,1.5-14.9,2.2-6.6,9.4-6.6,12.5-4.1s3.3,14.2,12.2,13.3,4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9-1.1,3.9-2.2,11.3,3.7,10.8,4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9,1.1-4.6,7.7-4.4,9.1.3s4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2s-2.8-8.7-2.8-11.6c0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4s-.8-23.9,1.4-24.9c9.1-4.2,5.2,17.4,14.1,14.6,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c2.8-.2,5.1-2.1,5.9-4.8.6-2,.4-4-.5-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-2",
    d: "m112.7,177.5v49.8c.6.3,1.2.5,1.9.6v-37.3c-.1-3.5,2-6.7,5.3-7.9,1.1-.4,2.2-.4,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9.6,5.6-1.9,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.2.8,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.9-4.3-1.5-8.7-1.6-13.2,0-5.2.3-11.4,1.4-14.9,2.2-6.6,9.4-6.6,12.5-4.1s3.3,14.2,12.2,13.3,4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7s5-22.7,17.8-21.6c7.2.6,7.4,26,6.3,29.9-1.1,3.9-2.2,11.3,3.7,10.8,4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9,1.1-4.6,7.7-4.4,9.1.3s4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2s-2.8-8.7-2.8-11.6c0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4s-.8-23.9,1.4-24.9c9.1-4.2,5.2,17.4,14.1,14.6,4.8-1.5,4.9-10.7,6.9-17.5.9-3.2,2.5-3.3,3.6-2.6v-29.4H112.7v16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-16",
    d: "m173,216.6c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3h0c1.8,0,3.3-1.5,3.3-3.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-16",
    d: "m192.7,225c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h0c1.5,0,2.8-1.2,2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-16",
    d: "m226,220.8c0-2.6-2.1-4.7-4.7-4.7s-4.7,2.1-4.7,4.7,2.1,4.7,4.7,4.7h0c2.6,0,4.7-2.1,4.7-4.7h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-16",
    d: "m139.2,220.8c0-1.3-1.1-2.3-2.3-2.3s-2.3,1.1-2.3,2.3,1.1,2.3,2.3,2.3,2.3-1,2.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-12",
    d: "m165,247.5c0-1-.8-1.9-1.9-1.9-1,0-1.9.8-1.9,1.9,0,1,.8,1.9,1.9,1.9,1,0,1.9-.8,1.9-1.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-12",
    d: "m186.6,244.7c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8h0c1.5,0,2.8-1.2,2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-12",
    d: "m212.4,255.5c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8,1.3,2.8,2.8,2.8h0c1.5,0,2.8-1.2,2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-12",
    d: "m126,241.4c0-1-.8-1.9-1.9-1.9-1,0-1.9.8-1.9,1.9,0,1,.8,1.9,1.9,1.9s1.9-.8,1.9-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-12",
    d: "m251.8,245.7c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3,1,2.3,2.3,2.3,2.3-1,2.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-12",
    d: "m305.8,236.3c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8,1.3,2.8,2.8,2.8h0c1.5,0,2.8-1.3,2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-12",
    d: "m296.2,247.5c0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1,2.1.9,2.1,2.1,2.1h0c1.1.1,2.1-.9,2.1-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-12",
    d: "m285.6,244.7c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3h0c1.8,0,3.3-1.5,3.3-3.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-2",
    d: "m323.8,213.8c-1.6-2.8-2.4-5.9-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.4-2.9,12.1-.8,1.5-.9,3.3-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c-.1-3.5,2-6.7,5.3-7.9,1-.3,11.2-2.6,13.4,9.7,1,5.6-1.8,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.8,2.8.8,12.4.8,19.6,0,4.5-1.5,6.3-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.9-4.3-1.5-8.7-1.6-13.2,0-5.2.3-11.4,1.5-14.9,2.2-6.6,9.4-6.6,12.5-4.1s3.3,14.2,12.2,13.3,4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9-1.1,3.9-2.2,11.3,3.7,10.8,4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9,1.1-4.6,7.7-4.4,9.1.3s4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2s-2.8-8.7-2.8-11.6c0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4s-.8-23.9,1.4-24.9c9.1-4.2,5.2,17.4,14.1,14.6,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c2.8-.2,5.1-2.1,5.9-4.8.6-1.9.4-3.9-.5-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-13",
    d: "m313.7,156.1c0,12.3-44,22.2-98.2,22.2s-98.2-9.9-98.2-22.2,44-22.2,98.2-22.2,98.2,10,98.2,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-13",
    d: "m109.1,215.6c-.1-.9-1.2-.4-1.3.2-.5,1.7-.2,3.5.9,4.9.6.8,2.8,1,2-1.1-.8-1.3-1.3-2.6-1.6-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-13",
    d: "m135.5,188.2c-.5-3.1-2.1-5.9-4.5-8-5.5-4.6-11.4-3.9-17,.2-.7.5.1,1.1.9.6,7.7-4.9,16.2-.8,18.1,7.4,1.1,4.8-2.1,16.5,1,20.7.9,1.2,3.3-.2,1.9-3.4-2-4.8.7-12.4-.4-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-13",
    d: "m153.1,221.8c-.1-.9-.8-1.4-1.4-.6-1.3,1.8-2.3,6.4.7,7.1.6.2,1.3-.6,1.4-1.2.1-1.8-.6-3.8-.7-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-13",
    d: "m184.9,198.4c-5.8-1.5-5.7-8-10.6-10.7-2.9-1.7-6.4-1.7-9.3,0-.7.4-.6,1.1.2.8,2.9-1,6.1-.4,8.3,1.7,1.8,1.7,2.6,4.7,3.8,6.7,1.6,2.5,4.1,4.9,7.2,3.9,1.1-.3,1.9-2,.4-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-13",
    d: "m145,184.6c-.5.2-.3,1.3.3,1.2,1.9-.2,3.9,0,5.4,1.5,1.2,1.4,2,3,2.5,4.7.4.9,1.7.4,1.8-.4.3-3.8-2.5-7.2-6.3-7.6-1.2-.2-2.5,0-3.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-13",
    d: "m215.4,209.3c-1.2-.7-4.2-7.6-4.8-8.9-.8-1.9-1.8-3.7-2.9-5.5-2-2.9-4.6-4.1-8-3.6-.7.1-.5.6.4.6,8,.6,8.6,16.5,13.5,19.4,2.7,1.6,3.4-1.1,1.8-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-13",
    d: "m234,190.8c-.8-.2-1.4.3-.6.6,3.2,1.4,5.4,4.3,6,7.7.3,1.3,2,1.2,1.9,0-.3-4.3-3.3-7.2-7.3-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-13",
    d: "m242.8,225.9c-.1-.6-.7-1-1.3-.9-.4.1-.7.3-.9.7-.8,1.2-1.4,2.5-.9,4,.4,1.2,1.6,2.2,2.9,1.6s.5-4.5.2-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-10",
    d: "m139,124.6v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.1,76.6-16h0v-26.9s-153.2,0-153.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-1",
    d: "m139,99.5v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.1,76.6-16h0v-26.9h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-13",
    d: "m139,77.5v24.8h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-24.8h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-2",
    d: "m139,77.5v47h1v-17.8c0-1,.1-1.9.4-2.9,1.1-3.6,6.1-4.3,8.3-1.2,1.6,2.2,2,3.3,2.6,6.8.7,3.6,1,7.3.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.8,2.5-8s2.1-12.7,5.6-12.8c6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7-.9,4.1-3.1,11.3,1.6,11.4s4.2-4.8,3.1-10.5.3-13,8-13.5c9.6-.6,10.5,20.3,9.5,25.3s1.3,9.1,4.7,6.6.2-5.1,0-7.5c-.3-3.1-1.2-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,2.6-1.7,3.9.1,4.7,2.2v-24h-153.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-16",
    d: "m200.7,130.7c0-2.3-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2,1.9,4.2,4.2,4.2h0c2.3,0,4.1-1.9,4.2-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-16",
    d: "m172.5,125.5c0-1-.8-1.9-1.9-1.9-1,0-1.9.8-1.9,1.9,0,1,.8,1.9,1.9,1.9h0c1,0,1.9-.9,1.9-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-16",
    d: "m180.9,134.4c0-1-.8-1.9-1.9-1.9-1,0-1.9.8-1.9,1.9,0,1,.8,1.9,1.9,1.9s1.9-.8,1.9-1.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-16",
    d: "m261.7,128.8c0-1.6-1.3-2.8-2.8-2.8-1.6,0-2.8,1.3-2.8,2.8,0,1.6,1.3,2.8,2.8,2.8h0c1.5,0,2.8-1.2,2.8-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-12",
    d: "m255.6,149c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3,1,2.3,2.3,2.3h0c1.2,0,2.3-1,2.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-12",
    d: "m277.2,154.1c0-1.3-1.1-2.3-2.3-2.3s-2.3,1.1-2.3,2.3,1.1,2.3,2.3,2.3h0c1.2.1,2.3-1,2.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-12",
    d: "m265,156.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4,1.4.6,1.4,1.4,1.4c.7,0,1.4-.6,1.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-12",
    d: "m157,147.1c0-1.3-1.1-2.3-2.3-2.3s-2.3,1.1-2.3,2.3,1.1,2.3,2.3,2.3,2.3-1,2.3-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-12",
    d: "m167.3,155.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4,1.4.6,1.4,1.4,1.4c.8.1,1.4-.6,1.4-1.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-12",
    d: "m190.3,155.5c0-1.3-1.1-2.3-2.3-2.3s-2.3,1.1-2.3,2.3,1.1,2.3,2.3,2.3,2.3-1,2.3-2.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-2",
    d: "m299.2,125.7c-.3-.9-.7-1.8-1.2-2.7-1.6-3.1-2.4-6.4-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-11.2-6.9-40.4-11.8-74.8-11.8s-64.6,5.1-75.3,12.1c-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c0,2.7-.7,5.3-1.9,7.6-.5.8-.8,1.8-.8,2.8,1.6,7.6,5.9,5,5.9,5v-19.4c0-1,.1-1.9.4-2.9,1.1-3.6,6.1-4.3,8.3-1.2,1.6,2.2,2,3.3,2.6,6.8.7,3.6,1,7.3.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.9,2.5-8s2.1-12.7,5.6-12.8c6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7-.9,4.1-3.1,11.3,1.6,11.4s4.2-4.8,3.1-10.5.3-13,8-13.5c9.6-.6,10.5,20.3,9.5,25.3s1.3,9.1,4.7,6.6.2-5.1,0-7.5c-.3-3.1-1.2-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,5-3.3,5.5,6.6,5.5,6.6v23.5s1.2,5.7,4.8,3.8c2-.9,3-3.2,2.4-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-13",
    d: "m153.1,122.2c0-.7-.9-.7-1.3-.4-.9.6-1.2,1.8-.6,2.7.1.1.2.3.3.4.5.4,1.1.3,1.5-.1.2-.2.3-.5.2-.8.1-.6,0-1.2-.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-13",
    d: "m136.2,117.2c0-.7-.9-.7-1.3-.4-.9.6-1.2,1.8-.6,2.7.1.1.2.3.3.4.5.4,1.1.3,1.5-.1.2-.2.3-.5.2-.8,0-.6-.1-1.1-.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-13",
    d: "m149.3,96.4c-3-1.9-7.6-2-9.7,1.2-.5.7.2.7.8.3,3.1-2.3,7.1-.9,9.2,1.9,2,3,3,6.5,2.8,10.1,0,1.1,1.1-1.8,1.1-3.8,0-3.7-.6-7.3-4.2-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-13",
    d: "m167.5,107c-1.2-1.9-3.2-3.1-5.4-3.2-.5,0-.9.6-.3.8,2.1.6,3.8,2.2,4.6,4.3,1,2.2,1.2,4.2,2.1,6.9.4,1.1,1.7.5,1.7-1.1-.2-2.8-1.1-5.5-2.7-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-13",
    d: "m190.5,110.8c-2.6-.2-4.6-3.7-6.1-4.6-1.5-.8-3.3-1-4.9-.6-.8.2-.5.7.4.6,1.4-.2,3.4,1.5,4.2,2.3.9.9,3.6,4.1,5.8,4.2,2.7.1,2.5-1.7.6-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-13",
    d: "m204.1,106.7c-.9-.1-1.5.3-.4.7,5.8,1.8,8.2,8.3,9.2,13.7.2,1.3.5.1.5-1,0-6.5-2.6-12.4-9.3-13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-13",
    d: "m215.2,137.1c0-.7-.9-.6-1.2-.2-.9,1.1-1.1,2.6-.5,3.8.4.5,1.1.7,1.7.3.4-.3.6-.7.5-1.1-.1-.9-.5-1.8-.5-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-13",
    d: "m238.2,148c-.2-.5-.5-.9-.9-1.2-.4-.4-1-.3-1.3.1q-.1.1-.1.2c-.5.8-.5,1.8-.1,2.6.5,1.9,3.3.8,2.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-13",
    d: "m287.8,75.1c0,9-32.3,16.3-72.2,16.3s-72.2-7.3-72.2-16.3,32.3-16.3,72.2-16.3,72.2,7.2,72.2,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-2",
    d: "m113.5,166.2s1.4,4.5,5.2,6.1,5.9.5,7.3,1.6c1.4,1.2,6.8,3.3,6.8,3.3,3.6-.4.5,2.3,7.3,4.9,2.9,1.1,9.2.2,12,.9s9.9-1.2,11.7-.9,4,4.9,9.2,6.6,10.3-2.3,14.8-2.1c3.5.2,8-.2,11.7.2,3.8.5,7.3,3.9,12.2,3.7s18.7.7,21.3-.7,3.1-4.2,6.3-3.3,10.6,2.1,13.8,1.9,8-3.5,10.1-2.8,16.2.9,19.9-.9,4.9-8.9,7.7-8.2,13.6,0,15.7-2.1,5.6-2.1,7.7-5.2c1.2-1.6,1-3.9-.6-5.2l-53.2,9-53,5.4-36.8-3.3-42-7.7-15.1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-2",
    d: "m204.5,138.6c-.1,0-.1-.1-.2-.1q.1.1.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-22",
    d: "m214,41.5h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-2",
    d: "m211.6,77.6c2.9,1.4,6,2.4,9.2,2.9v-5.1c-3.2-.6-6.3-1.6-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-22",
    d: "m211.6,72.3c2.9,1.5,6,2.5,9.2,3v-5.1c-3.2-.6-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-22",
    d: "m211.6,82.1h9.2v-1.7c-3.2-.5-6.3-1.5-9.2-2.9v4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-2",
    d: "m211.6,67c2.9,1.5,6,2.6,9.2,3.2v-5.1c-3.2-.7-6.3-1.8-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-22",
    d: "m220.8,41.5h-7.1c2.3,1.2,4.6,2.2,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-2",
    d: "m213.7,41.5h-2.1v4.1c2.9,1.8,6,3.1,9.2,4v-5.2c-2.5-.7-4.8-1.7-7.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-22",
    d: "m211.6,51c2.9,1.7,6,3,9.2,3.8v-5.2c-3.2-.9-6.3-2.2-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-22",
    d: "m211.6,61.6c2.9,1.6,6,2.7,9.2,3.4v-5.1c-3.2-.7-6.3-2-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-2",
    d: "m211.6,56.3c2.9,1.6,6,2.8,9.2,3.6v-5.2c-3.2-.8-6.3-2.1-9.2-3.8v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-21",
    d: "m211.6,41.5c0,.3,2.1.6,4.6.6s4.6-.3,4.6-.6-2.1-.6-4.6-.6-4.6.3-4.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-22",
    d: "m214,41.5c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3-2.2.1-2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-2",
    d: "m215.9,36.6l-.2,4.6c0,.2.2.4.4.5.2,0,.4-.2.5-.4h0l-.2-4.6c0-.1-.1-.3-.3-.3,0-.1-.2,0-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-22",
    d: "m182.3,32.7h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-2",
    d: "m180,68.8c2.9,1.4,6,2.4,9.2,2.9v-5.1c-3.2-.6-6.3-1.6-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-1",
    d: "m180,63.5c2.9,1.5,6,2.5,9.2,3v-5.1c-3.2-.6-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    className: "cls-1",
    d: "m180,73.4h9.2v-1.7c-3.2-.5-6.3-1.5-9.2-2.9v4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    className: "cls-2",
    d: "m180,58.2c2.9,1.5,6,2.6,9.2,3.2v-5.1c-3.2-.7-6.3-1.8-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    className: "cls-1",
    d: "m189.2,32.7h-7.1c2.3,1.2,4.6,2.2,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-2",
    d: "m182,32.7h-2.1v4.2c2.9,1.8,6,3.1,9.2,4v-5.2c-2.4-.8-4.8-1.7-7.1-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-1",
    d: "m180,42.2c2.9,1.7,6,3,9.2,3.8v-5.2c-3.2-.9-6.3-2.2-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-1",
    d: "m180,52.9c2.9,1.6,6,2.7,9.2,3.4v-5.2c-3.2-.7-6.3-2-9.2-3.6v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-2",
    d: "m180,47.6c2.9,1.6,6,2.8,9.2,3.6v-5.2c-3.2-.8-6.3-2.1-9.2-3.8v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-16",
    d: "m180,32.7c0,.3,2.1.6,4.6.6s4.6-.3,4.6-.6-2.1-.6-4.6-.6-4.6.3-4.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-1",
    d: "m182.3,32.7c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3-2.2.2-2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-2",
    d: "m184.3,27.8l-.2,4.6c0,.2.2.4.4.5.2,0,.4-.2.5-.4h0l-.2-4.6c0-.1-.1-.3-.3-.3-.1,0-.2.1-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-22",
    d: "m248.7,32.7h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-2",
    d: "m246.3,68.8c2.9,1.4,6,2.4,9.2,2.9v-5.1c-3.2-.6-6.3-1.6-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-10",
    d: "m246.3,63.5c2.9,1.5,6,2.5,9.2,3v-5.1c-3.2-.6-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-10",
    d: "m246.3,73.4h9.2v-1.7c-3.2-.5-6.3-1.5-9.2-2.9v4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-2",
    d: "m246.3,58.2c2.9,1.5,6,2.6,9.2,3.2v-5.1c-3.2-.7-6.3-1.8-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-10",
    d: "m255.5,32.7h-7.1c2.3,1.2,4.6,2.2,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-2",
    d: "m248.4,32.7h-2.1v4.2c2.9,1.8,6,3.1,9.2,4v-5.2c-2.5-.8-4.9-1.7-7.1-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-10",
    d: "m246.3,42.2c2.9,1.7,6,3,9.2,3.8v-5.2c-3.2-.9-6.3-2.2-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    className: "cls-10",
    d: "m246.3,52.9c2.9,1.6,6,2.7,9.2,3.4v-5.2c-3.2-.7-6.3-2-9.2-3.6v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-2",
    d: "m246.3,47.6c2.9,1.6,6,2.8,9.2,3.6v-5.2c-3.2-.8-6.3-2.1-9.2-3.8v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    className: "cls-12",
    d: "m246.3,32.7c0,.3,2.1.6,4.6.6s4.6-.3,4.6-.6-2.1-.6-4.6-.6-4.6.3-4.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    className: "cls-10",
    d: "m248.7,32.7c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3-2.2.2-2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    className: "cls-2",
    d: "m250.6,27.8l-.2,4.6c0,.2.2.4.4.5s.4-.2.5-.4h0l-.2-4.6c0-.1-.1-.3-.3-.3-.1,0-.2.1-.2.2"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    className: "cls-17",
    d: "m186.9,98.4c2.5-4.7,2.7-9.4-.7-9.7-1.3.1-2.6.6-3.6,1.4,1.4-2.1,3.3-4.7,4-5.8,1.8-2.9,2-4.7,1.5-5.8-.3-.6-.6-.6-1-.1-3,3.6-11.9,17.9-13.2,21.1-1,2.4-.7,3.6-.1,4.4.2.3.5.3.6-.1.4-.8.9-1.7,1.3-2.6.5,1.8,2.1,3.1,4,3.1,2.4.2,5.1-1.9,7.2-5.9Zm-1.4-8.1c.9.1,1.2,2.6-1.4,7-2.6,4.5-4.6,5.5-5.9,5.1-1.1-.3-1.5-1.6-1.5-2.8,1.5-2.9,3.5-5.5,5.8-7.9,1.3-1.2,2.2-1.6,3-1.4Zm6.8,7.6c2.6,2.5,5.4,1.6,7.5-.6,1.8-1.9,2.3-4.3,1.7-5.3-.6-.9-1.3-1.7-2.2-2.2-1.9-1.3-6.1.5-9.1,5.5s-1.5,10.1,3.5,10.4c3.1.1,6.1-1.3,8.1-3.8.6-.7.9-1.5.9-2.4-.1-.4-.5-.4-.7-.1-1.9,2.5-5,5.5-8.3,5.1-2.2-.4-3-3-1.4-6.6Zm.4-.8c.1-.2.2-.4.4-.7,2.1-3.7,5.6-5.8,6.4-5.1.5.5-.5,2.5-1.9,4.1-1.3,1.5-3.1,3.1-4.9,1.7Zm14.2-6.9c-1.9,3-3.8,6.3-4.8,8.2-2.2,4.5-.3,7.6,2.3,7.8,3.2.3,6.1-3,6.7-4.1.4-.7.6-1.5.6-2.2-.1-.6-.6-.5-.8-.1-1.7,2.9-4.2,5.6-6,5.4-1.7-.2-1.9-2.7-.4-5.5,1.8-3.2,4.3-7,6-9.5,1-.1,2.1-.1,3.1.1.6,0,.8-.2.5-.7-.5-.9-1.4-1.4-2.4-1.4,1.1-2,1.2-3.3.8-4.5-.2-.5-.6-.6-1-.1-1.2,1.5-2.3,3.1-3.4,4.7-1.1.1-2.2,0-3.3-.1-.6-.1-.9.2-.5.8.7.8,1.6,1.2,2.6,1.2Zm22.5.6c2.4-2.8,2.3-5.1.7-7-1.5-1.5-3.8-1.9-5.8-1.1-2.6,1.3-4.7,3.3-6.3,5.7-.2.4-.2.6.3.7,1.6.4,3.1-.4,4.5-1.9,2-2.2,4.6-4.3,6-2.7,1.6,1.9-2.5,7.2-11.2,9.1-.5.1-.6.4-.4.7,1.9,2.7,4.6.4,6.2,1.6,1.2,1-.2,3.7-2.3,6-2.3,2.6-5.8,3.9-7.7,2.6-1.4-1-1.1-3.9,1.1-6.9.2-.3.1-.6-.3-.6-1.5,0-2.9,1-3.5,2.4-1.1,2.2-.4,4.9,1.6,6.3,2.4,1.9,7.2,2.1,10.9-1.8,3.2-3.4,4-6.8,2.1-8.7-.5-.4-1.1-.8-1.8-.9,2.3-.7,4.3-1.9,5.9-3.5Zm15.5-3.5c.2-1.2-.3-2.4-1.2-3.1-1.1-.8-2.5-1-3.8-.7-1.8.4-6.3,2.3-10.6,8.6-4.4,6.6-4.4,12.6-1,14.9,2.8,1.9,6.7,1.5,9.8-3.2,3.1-4.8,2.2-8.3-.1-10-1.7-1.2-3.9-1.3-5.7-.3,4.2-6,8.9-8.5,10.4-8.2.6.1-.1,2-.9,3.7-.9,2-.8,3.8.2,4.6.4.3.6.3.9-.1,1-1.9,1.7-4,2-6.2Zm-16,13.4c1.8-5.2,6.2-6.7,7.8-5.9,1.5.8,1.1,3.8-.8,7-2,3.4-5,5.1-6.5,4-.8-.5-1.5-2.4-.5-5.1Zm32.4-13.4c.4,0,.5-.1.4-.5-.3-1.4-1.6-2.4-3-2.4-2.1-.1-6,.8-9.7.4-.4,0-.6.1-.5.5.1.5.3.9.6,1.2-1.6,2.1-3.1,4.4-4.5,6.7-1.2,2.2-.8,3.6-.2,4.4.3.3.5.4.8,0,1.9-2.2,4.5-3.2,5.9-2.3,1.3.8.8,4-1.4,7.3-2.1,3.1-5.9,5.4-7.8,4.1-1.5-1-1.2-4.3.9-7.2.2-.3.1-.6-.2-.6-1.5,0-2.9.9-3.5,2.4-1.2,2.3-.5,5.1,1.7,6.5,2.9,1.8,7.8,1.3,11.1-3.4,3.7-5.2,2.7-8.3.8-10-1.5-1.1-3.5-1.5-5.3-.9,1.5-2,2.9-4,4.4-5.8h.6c2.7,0,5.4-.6,8.9-.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    className: "cls-15",
    x1: 217.2,
    y1: 105.5,
    x2: 206.2,
    y2: 172.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    className: "cls-9",
    x1: 197.3,
    y1: 166.5,
    x2: 206.3,
    y2: 172.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    className: "cls-7",
    x1: 197.4,
    y1: 166.5,
    x2: 187.4,
    y2: 110.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    className: "cls-8",
    d: "m156.74,113.09c.8-5.3-.7-9.8-4-8.9-1.2.5-2.2,1.4-2.8,2.6.6-2.5,1.5-5.6,1.7-6.8.7-3.3.3-5.1-.6-6-.5-.5-.8-.4-1,.2-1.6,4.5-5.1,20.8-5.2,24.3-.1,2.6.6,3.6,1.4,4.2.3.2.5.1.6-.3.1-.9.3-2,.4-2.9,1.1,1.5,3,2.2,4.8,1.6,2.3-.6,4-3.4,4.7-8Zm-4.1-7.1c.9-.2,2,2,1.1,7-1,5.1-2.4,6.8-3.8,6.8-1.1.1-2-1-2.4-2.1.5-3.2,1.4-6.4,2.7-9.4.9-1.5,1.6-2.2,2.4-2.3Zm8.9,4.9c3.3,1.4,5.6-.3,6.8-3.2,1.1-2.4.7-4.9-.3-5.6-.7-.6-1.7-1.1-2.7-1.3-2.2-.6-5.6,2.6-6.7,8.2s2,10,6.9,8.5c3-1,5.3-3.3,6.3-6.3.3-.8.3-1.8,0-2.6-.3-.3-.6-.2-.7.1-.9,3-2.9,6.9-6.1,7.7-2.1.5-3.7-1.6-3.5-5.5Zm.1-1c0-.2.1-.5.1-.7.8-4.2,3.3-7.4,4.3-7,.7.3.4,2.5-.4,4.5-.6,1.8-1.7,3.9-4,3.2Zm11.1-11.3c-.8,3.5-1.5,7.2-1.7,9.4-.6,5,2.3,7.2,4.8,6.6,3.1-.8,4.7-4.9,4.9-6.1.2-.8.1-1.6-.2-2.3-.3-.5-.7-.3-.8.2-.6,3.3-2,6.7-3.8,7.1-1.6.4-2.7-1.9-2.3-5,.5-3.6,1.7-8,2.4-11,.9-.5,1.9-.8,3-1,.6-.2.7-.5.3-.9-.7-.7-1.8-.9-2.7-.5.3-2.3,0-3.5-.7-4.5-.3-.4-.7-.3-.9.3-.6,1.8-1.1,3.7-1.6,5.6-1,.4-2.1.8-3.1,1.1-.6.1-.7.5-.2.9.6.3,1.7.4,2.6.1Zm21.3-7.2c1.3-3.4.4-5.5-1.7-6.8-2-.9-4.3-.5-5.8,1-2,2.1-3.3,4.7-3.9,7.5-.1.4.1.6.6.6,1.7-.1,2.7-1.5,3.5-3.3,1.2-2.8,2.9-5.7,4.7-4.6,2.1,1.3.1,7.6-7.4,12.4-.5.3-.4.6-.1.8,2.7,1.8,4.5-1.2,6.4-.6,1.5.5,1.1,3.6-.1,6.4-1.3,3.2-4.1,5.7-6.3,5-1.6-.5-2.4-3.2-1.3-6.9.1-.4-.1-.6-.5-.5-1.4.6-2.4,1.9-2.4,3.4-.2,2.4,1.3,4.7,3.7,5.4,2.9.9,7.5-.5,9.6-5.4,1.8-4.3,1.4-7.8-1-8.9-.6-.2-1.3-.3-2-.3,1.6-1.2,3-3.1,4-5.2Zm13.4-8.5c-.2-1.2-1.1-2.2-2.3-2.5-1.3-.4-2.7-.1-3.8.7-1.5,1-5.2,4.3-7,11.7-1.8,7.6.2,13.3,4.1,14.3,3.3.8,6.8-.9,8.1-6.4,1.3-5.6-.7-8.5-3.6-9.3-2-.6-4.1.1-5.5,1.7,1.8-7.1,5.4-11,7-11.2.6-.1.5,1.9.4,3.8-.2,2.2.6,3.8,1.8,4.2.5.2.7.1.8-.4.5-2.3.4-4.5,0-6.6Zm-10.5,18.1c-.1-5.5,3.6-8.4,5.3-8.2,1.7.3,2.3,3.2,1.6,6.9-.7,3.9-3,6.5-4.7,6-.9-.3-2.2-1.8-2.2-4.7Zm25.9-23.7c.4-.1.5-.3.2-.6-.8-1.2-2.3-1.7-3.7-1.2-2,.6-5.3,2.8-8.9,3.7-.4.1-.5.3-.3.6.2.4.6.7,1,1-.8,2.6-1.4,5.2-1.9,7.8-.4,2.5.5,3.7,1.3,4.2.4.2.6.2.8-.3,1-2.7,3.2-4.5,4.7-4.2,1.5.3,2.1,3.5,1.2,7.3-.9,3.6-3.7,7.1-5.9,6.5-1.8-.5-2.6-3.7-1.6-7,.1-.4-.1-.6-.4-.5-1.4.5-2.4,1.9-2.4,3.4-.4,2.6,1.3,5,3.8,5.6,3.4.7,7.8-1.5,9.3-7,1.7-6.1-.3-8.7-2.7-9.6-1.8-.5-3.8-.2-5.3,1,.7-2.4,1.4-4.7,2.1-7,.2-.1.4-.1.6-.2,2.3-1,4.7-2.5,8.1-3.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    className: "cls-5",
    d: "m199.57,134.9c-8.9-7.4-18.3-13.2-19.6-11.1-.4.6.4,2.2,2,4.2-3.9-3.5-8.7-8-10.7-9.8-5.3-4.8-8.9-7-11.4-8-1.2-.5-1.4-.3-.5.6,6.6,6.5,33,29.8,39.2,34.6,4.5,3.5,7,4.7,8.8,5.3.7.2.7,0,0-.5-1.5-1.3-3.3-2.7-4.8-4,3.8,1.7,6.5,2.2,7.3.9.9-1.4-2.7-5.8-10.3-12.2Zm-16.6-8.7c.5-.5,5.6,2.3,13.7,9.3,8.3,7.2,10,9.9,8.8,10.3-.9.4-3.7-.9-6-2.3-5.1-4.2-9.9-8.7-14.5-13.5-2-2.3-2.5-3.4-2-3.8Zm17,4.4c5.6,1.1,4.6-1.9.6-6.1-3.4-3.6-8.1-6.8-10.3-7.6-1.6-.6-3.3-1-5.1-1.1-3.1-.2-.5,4.9,8.7,13s19.9,13.2,21.7,9.9c1.1-2-1.3-6.2-5.5-10.3-1.4-1.4-3-2.6-4.7-3.5-.8-.3-.9-.1-.3.4,4.6,4.4,9.8,10.2,8.2,12-1,1.2-6.4-1.3-13.3-6.7Zm-1.6-1.3c-.4-.3-.8-.7-1.2-1-6.8-5.9-10.3-11-8.6-10.6,1.1.2,4.9,3.3,7.7,6.2,2.6,2.5,5.4,5.7,2.1,5.4h0Zm-10.2-18.3c5.6,5,11.6,10.2,15.3,13.2,8.4,6.9,15.1,9.3,16.3,7.7,1.5-1.8-4.5-7.9-6.6-9.6-1.3-1.2-2.8-2.2-4.4-3.1-1.2-.6-1.2-.2-.3.5,5.4,4.7,10.2,9.6,9.3,10.6-.8.9-5.9-1.9-11.2-6.3-6.1-5.1-13-11.3-17.7-15.6,0-.8.3-1.6.9-2.1.2-.4-.3-.8-1.3-1.2-1.2-.4-2.8-1-3.4.1-2.6-2.4-5.6-4.4-8.8-5.9-1-.5-1.3-.3-.4.6,1.5,1.5,4.8,4.6,8.7,8.1-.1.8-.5,1.6-1,2.3-.3.3.1.8,1.4,1.3,1.1,0,2.7.2,3.2-.6h0Zm6.7-15.3c-5-5-9.7-7.7-13.8-8.9-3.3-.9-4.8.4-3.7,2.8s5.7,7.6,10,11.3c.7.6,1.2.9,1.6.6,1.3-.6-.1-2.7-2.8-5.5-4-4.1-7.5-8.5-3.9-7.5,4.3,1.2,13.8,10.4,15.5,18.8.2.6.7,1,1.4,1.2,5.8,1.8,2-2.8,4.8-2.4,2.3.3,7.4,4.6,11.5,8.8,4.6,4.7,6.5,8.8,3.2,8.5-2.4-.2-8-3.8-13.6-9-.6-.5-1.1-.7-1.2-.5-.5.7.8,2.8,3.9,5.3,2.6,2.2,8.5,5.9,13.1,6.4,4.3.5,6.1-2.6-.9-9.9-6.1-6.4-12.7-11-16.9-11.9-.8-.2-1.6-.1-2.3.2-1.5-3.1-3.5-5.9-5.9-8.3Zm-3.1-15.2c-2.9-1.8-5-2.7-6.6-2.9-1.4-.2-2.7.3-2.3,1.9.4,1.8,3,7.2,14.8,17.8,12.1,10.9,24.2,18.2,29.6,18.5,4.6.3,4.6-3-4-10.8-8.9-7.9-16.1-11.5-20.2-11.9-3-.3-3.5,1.3-2,3.7-11.1-10-14.8-16.3-13.8-17,.4-.3,3.9,2.4,7.2,5,3.8,3.1,7.4,5.1,9.3,5.3.7.1.7-.1-.1-.8-3.8-3.1-7.7-6.1-11.9-8.8Zm23,27.4c-10.1-7.6-11.9-12.5-9.8-12.6s7.9,3.7,14,9c6.3,5.5,8.9,9.6,6.4,9.4-1.4,0-5.4-1.8-10.6-5.8Zm-18.8-39c.2-.3-.1-.5-.9-.9-2.9-1.4-5-1.8-5.5-.7-.7,1.3.1,5.2-1.6,7.3-.2.3.1.6.8.9.8.4,1.7.8,2.7,1.1,4.6,4.3,8.9,8.2,12.4,11.2,4.1,3.5,7.1,4.9,8.8,5.4.7.2.9.1.2-.5-3.9-4-5.3-7-3.2-6.9,1.9.1,8.3,4.2,14.3,9.7,5.7,5.2,9.5,10.7,6.3,10.5-2.4-.2-9-4.4-14.2-9.2-.6-.5-1.2-.8-1.2-.5-.3.8.5,2.6,3.9,5.3,3.5,2.8,9.5,6.5,13.6,6.6,4.4.1,4.5-4-4.1-12-9.5-8.8-16.1-11.8-19.9-12.5-2.2-.4-3.9.5-3.1,2.7-3.7-3.5-7.3-6.9-10.7-10.2.1-.1.2-.3.2-.4.4-2-.2-4.7,1.2-6.9Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 5.9,
    width: 430,
    height: 273
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/Cake.48841a68b1220070f134a6c43fb5781d.svg";
export { ForwardRef as ReactComponent };